import {
  CAROUSEL_TARGET_FACILITY,
  CAROUSEL_TARGET_PATIENT,
  CAROUSEL_TARGET_PROFESSIONAL,
} from "./mapCarouselConstants";

/**
 * Extension point (future): granular carousel audiences (e.g. `professional-chartmind` vs `pro2`,
 * dashboard vs map placement) may get distinct slide sets in Firestore / admin. Until then,
 * all targeting collapses to {@link CAROUSEL_TARGET_PATIENT} | {@link CAROUSEL_TARGET_PROFESSIONAL}
 * | {@link CAROUSEL_TARGET_FACILITY} via {@link getMapCarouselViewerSegment}. A follow-up could
 * introduce `getMapCarouselPlacementAudience(role, placement)` while keeping this function as the
 * backward-compatible segment resolver for existing `publicConfig/mapCarousel` docs.
 */

const FACILITY_AUDIENCE_ROLES = new Set([
  "facility",
  "department-admin",
  "chartmind-admin",
  "chartmind-kijabe",
  "chartmind-supervisor",
  "llm-manager-global",
  "llm-manager-regional",
  "system-medical-admin",
  "dscr-admin",
]);

const PROFESSIONAL_ROLES = new Set([
  "professional",
  "professional-chartmind",
  "professional-reviewer",
  "pro2",
]);

/**
 * Map effective app role to CareMap carousel segment (for global slide targeting).
 * Anonymous / unknown consumers → patient.
 * @param {string | null | undefined} role
 * @returns {typeof CAROUSEL_TARGET_PATIENT | typeof CAROUSEL_TARGET_PROFESSIONAL | typeof CAROUSEL_TARGET_FACILITY}
 */
export function getMapCarouselViewerSegment(role) {
  if (!role || typeof role !== "string") {
    return CAROUSEL_TARGET_PATIENT;
  }
  if (FACILITY_AUDIENCE_ROLES.has(role)) {
    return CAROUSEL_TARGET_FACILITY;
  }
  if (PROFESSIONAL_ROLES.has(role)) {
    return CAROUSEL_TARGET_PROFESSIONAL;
  }
  return CAROUSEL_TARGET_PATIENT;
}
